import { FC } from "react";

interface TelephoneIconSVGProps {
    className?: string;
}

const TelephoneIconSVG: FC<TelephoneIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="64"
            height="65"
            viewBox="0 0 64 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M58.6666 45.6199V53.6199C58.6696 54.3626 58.5175 55.0977 58.2199 55.7782C57.9224 56.4587 57.486 57.0695 56.9388 57.5716C56.3915 58.0737 55.7454 58.4559 55.0419 58.6938C54.3384 58.9318 53.5929 59.0201 52.8532 58.9533C44.6475 58.0617 36.7652 55.2577 29.8399 50.7666C23.3968 46.6724 17.9341 41.2097 13.8399 34.7666C9.33318 27.8098 6.52855 19.8893 5.65324 11.6466C5.5866 10.9092 5.67424 10.166 5.91057 9.46427C6.14691 8.76257 6.52676 8.11777 7.02595 7.57092C7.52513 7.02407 8.13272 6.58716 8.81001 6.28799C9.48731 5.98883 10.2195 5.83396 10.9599 5.83327H18.9599C20.2541 5.82053 21.5087 6.27881 22.4899 7.12269C23.4712 7.96656 24.1121 9.13846 24.2932 10.4199C24.6309 12.9801 25.2571 15.4939 26.1599 17.9133C26.5187 18.8677 26.5963 19.905 26.3837 20.9023C26.171 21.8995 25.6769 22.8149 24.9599 23.5399L21.5732 26.9266C25.3694 33.6027 30.8971 39.1305 37.5732 42.9266L40.9599 39.5399C41.6849 38.823 42.6003 38.3289 43.5976 38.1162C44.5948 37.9035 45.6321 37.9812 46.5866 38.3399C49.006 39.2427 51.5197 39.869 54.0799 40.2066C55.3753 40.3894 56.5583 41.0418 57.404 42.0399C58.2497 43.038 58.699 44.3121 58.6666 45.6199Z"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TelephoneIconSVG;
